"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.canSubmitReads = void 0;
var allowSubmissionForNonComms = function (states) {
    return !states.isSmart || states.isNonComms;
};
var canSubmitReads = function (states) {
    return states.isActive &&
        !states.isBeforeSupplyStart &&
        allowSubmissionForNonComms(states);
};
exports.canSubmitReads = canSubmitReads;
